var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show === true)?_c('img',_vm._b({attrs:{"src":_vm.imagePath,"tabindex":_vm.tabIndexEnabled ? 0 : false}},'img',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }